import { closestCenter, type CollisionDetection, type UniqueIdentifier } from '@dnd-kit/core';

/**
 * Евклидово расстояние между центрами двух прямоугольников.
 * из тех методов, что экспортируется ничего похожего нет, поэтому пришлось реализовать своё решение.
 * Без текущего решения плейсхолдер, куда вставится элемент после drop-а — рассчитывается и показывается некорректно.
 *
 * @param rectA {top: number; left: number; width: number; height: number}
 * @param rectB {top: number; left: number; width: number; height: number}
 * @returns number
 *
 * @kind helper
 */
function centerDistance(
    rectA: { top: number; left: number; width: number; height: number },
    rectB: { top: number; left: number; width: number; height: number }
): number {
    const ax = rectA.left + rectA.width / 2;
    const ay = rectA.top + rectA.height / 2;
    const bx = rectB.left + rectB.width / 2;
    const by = rectB.top + rectB.height / 2;

    return Math.sqrt((ax - bx) ** 2 + (ay - by) ** 2);
}

export const getCollisionDetection = (withLevels = true) => {
    const collisionDetection: CollisionDetection = (args) => {
        const { collisionRect, droppableRects, droppableContainers } = args;
        const targetCenter = collisionRect.top + collisionRect.height / 2;

        let isNodeFind = false;
        let resultId: UniqueIdentifier | null = null;

        for (const container of droppableContainers) {
            if (isNodeFind) {
                break;
            }

            const { id } = container;
            const rect = droppableRects.get(id);

            if (!rect) {
                continue;
            }

            const { top, height } = rect;

            if (String(id).includes('delimiter') || id === 'end') {
                if (resultId === null) {
                    resultId = id;
                } else {
                    // Из двух кандидатов-разделителей выбираем ближайший к центру collisionRect
                    const prevRect = droppableRects.get(resultId);

                    if (prevRect && centerDistance(rect, collisionRect) < centerDistance(prevRect, collisionRect)) {
                        resultId = id;
                    }
                }

                continue;
            }

            /**
             * Для определения коллизии с дропом активной строки в другую строку (активная строка становится дочерней для текущей)
             * используется минимальное расстояние между центрами строк
             * 12 - минимальное расстояние между центрами строк при котором считаем что коллизия есть и активная строка может стать дочерней у текущей
             */
            if (withLevels && Math.abs(targetCenter - (top + height / 2)) <= 12) {
                isNodeFind = true;
                resultId = id;
            }
        }

        if (resultId !== null) {
            return [{ id: resultId }];
        }

        return closestCenter(args);
    };

    return collisionDetection;
};
